module.exports = __webpack_public_path__ + "static/media/genisis3.d97113e8.jpg";